import types from "./types";

const INITIAL_STATE = {
  CalibrationDevices: null,
  CalibrationDevicesError: null,
  CalibrationDevicesLoading: false,

  //create
  createCalibrationDevices: null,
  createCalibrationDevicesError: null,
  createCalibrationDevicesLoading: false,

  //update
  updateCalibrationDevices: null,
  updateCalibrationDevicesError: null,
  updateCalibrationDevicesLoading: false,

  //delete
  deleteCalibrationDevices: null,
  deleteCalibrationDevicesError: null,
  deleteCalibrationDevicesLoading: false,

  //single item

  singleItem: null,
};

const CalibrationDevicesReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.GET_CALIBRATIONDEVICES_START:
      return {
        ...state,
        CalibrationDevices: null,
        CalibrationDevicesError: null,
        CalibrationDevicesLoading: true,
      };
    case types.GET_CALIBRATIONDEVICES_SUCCESS:
      return {
        ...state,
        CalibrationDevices: action.payload,
        CalibrationDevicesLoading: false,
      };
    case types.GET_CALIBRATIONDEVICES_ERROR:
      return {
        ...state,
        CalibrationDevicesError: action.payload,
        CalibrationDevicesLoading: false,
      };
    case types.GET_CALIBRATIONDEVICES_RESET:
      return {
        ...state,
        CalibrationDevicesError: null,
        CalibrationDevicesLoading: false,
      };
    //create

    case types.CREATE_CALIBRATIONDEVICES_START:
      return {
        ...state,
        createCalibrationDevices: null,
        createCalibrationDevicesError: null,
        createCalibrationDevicesLoading: true,
      };
    case types.CREATE_CALIBRATIONDEVICES_SUCCESS:
      return {
        ...state,
        createCalibrationDevices: action.payload,
        createCalibrationDevicesLoading: false,
      };
    case types.CREATE_CALIBRATIONDEVICES_ERROR:
      return {
        ...state,
        createCalibrationDevicesError: action.payload,
        createCalibrationDevicesLoading: false,
      };
    case types.CREATE_CALIBRATIONDEVICES_RESET:
      return {
        ...state,
        createCalibrationDevices: null,
        createCalibrationDevicesError: null,
        createCalibrationDevicesLoading: false,
      };
    //delete

    case types.DELETE_CALIBRATIONDEVICES_START:
      return {
        ...state,
        deleteCalibrationDevices: null,
        deleteCalibrationDevicesError: null,
        deleteCalibrationDevicesLoading: true,
      };
    case types.DELETE_CALIBRATIONDEVICES_SUCCESS:
      return {
        ...state,
        deleteCalibrationDevices: action.payload,
        deleteCalibrationDevicesLoading: false,
      };
    case types.DELETE_CALIBRATIONDEVICES_ERROR:
      return {
        ...state,
        deleteCalibrationDevicesError: action.payload,
        deleteCalibrationDevicesLoading: false,
      };
    case types.DELETE_CALIBRATIONDEVICES_RESET:
      return {
        ...state,
        deleteCalibrationDevices: null,
        deleteCalibrationDevicesError: null,
        deleteCalibrationDevicesLoading: false,
      };

    //update
    case types.UPDATE_CALIBRATIONDEVICES_START:
      return {
        ...state,
        updateCalibrationDevices: null,
        updateCalibrationDevicesError: null,
        updateCalibrationDevicesLoading: true,
      };
    case types.UPDATE_CALIBRATIONDEVICES_SUCCESS:
      return {
        ...state,
        updateCalibrationDevices: action.payload,
        updateCalibrationDevicesLoading: false,
      };
    case types.UPDATE_CALIBRATIONDEVICES_ERROR:
      return {
        ...state,
        updateCalibrationDevicesError: action.payload,
        updateCalibrationDevicesLoading: false,
      };
    case types.UPDATE_CALIBRATIONDEVICES_RESET:
      return {
        ...state,
        updateCalibrationDevices: null,
        updateCalibrationDevicesError: null,
        updateCalibrationDevicesLoading: false,
      };
    //singleItem
    // case types.SINGLE_CALIBRATIONDEVICES_START:
    // 	return {
    // 		...state,
    // 		updateCalibrationDevices: null,
    // 		updateCalibrationDevicesError: null,
    // 		updateCalibrationDevicesLoading: true,
    // 	};
    // case types.SINGLE_CALIBRATIONDEVICES_SUCCESS:
    // 	return {
    // 		...state,
    // 		updateCalibrationDevices: action.payload,
    // 		updateCalibrationDevicesLoading: false,
    // 	};
    // case types.SINGLE_CALIBRATIONDEVICES_ERROR:
    // 	return {
    // 		...state,
    // 		updateCalibrationDevicesError: action.payload,
    // 		updateCalibrationDevicesLoading: false,
    // 	};
    // case types.SINGLE_CALIBRATIONDEVICES_RESET:
    // 	return {
    // 		...state,
    // 		updateCalibrationDevicesError: null,
    // 		updateCalibrationDevicesLoading: false,
    // 	};

    default:
      return { ...state };
  }
};

export default CalibrationDevicesReducer;
